<template>
  <card class="base-balance-page-card">
    <template v-slot:default>
      <div class="last-updated">מעודכן ל-{{ formattedDate }}</div>
      <div class="source">{{ sourceDisplayName }}</div>
      <div class="credentials-name">{{ credentialsName }}</div>
      <div class="amount" :class="{ negative: amount < 0 }">₪ {{ formattedAmount }}</div>
    </template>
    <template v-slot:footer>
      <div class="account">{{ account }}</div>
    </template>
  </card>
</template>

<script>
import _ from 'lodash';
import BaseUI from 'base-ui';
import moment from 'moment';

import sourcesFields from '../../../../../constants/sourcesFields';
import moneyUtils from '../../../../../utils/money';

export default {
  name: 'BaseBalancePageCard',
  components: {
    Card: BaseUI.Card,
  },
  props: {
    account: { type: String, required: true },
    source: { type: String, required: true },
    amount: { type: Number, required: true },
    credentialsName: { type: String, required: true },
    lastUpdated: { type: String, required: true },
  },
  computed: {
    formattedDate() {
      return moment(this.lastUpdated).format('DD.MM.YY, HH:mm');
    },
    sourceDisplayName() {
      return _.find(sourcesFields.allSourceFields, source => source.backendName === this.source).displayName;
    },
    formattedAmount() {
      return moneyUtils.formatAmount(this.amount);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .base-balance-page-card {
    margin: 0 0 16px;
    font-family: SimplerPro;

    .last-updated {
      font-size: 12px;
      color: $riseup_gray_2;
    }

    .source {
      font-family: GretaSans;
      margin-top: 3px;
      font-size: 24px;
      font-weight: bold;
    }

    .account {
      margin-top: 6px;
      font-size: 16px;
    }

    .credentials-name {
      margin-top: 3px;
    }

    .amount {
      margin-top: 28px;
      direction: ltr;
      text-align: right;
      font-size: 46px;
      font-weight: bold;
      color: $riseup_green;

      &.negative {
        color: $riseup_coral;
      }
    }
  }
</style>
